import { useProductsStore } from "@/store/products";
import { useMagasinStore } from "@/store/magasin";
import { useDatalayerStore } from "@/store/datalayer";
import { pushProps, usePush } from "@/components/pages/mixins/push-mixin"
import { useContainerProductList } from "@/containers/mixin/product-list.mixin";
import { useClientStore } from "@/store/client";

import pagesNiv3et4Codes from "@/utils/pages-niv3&4-codes";
import contentTypes from "@/utils/product-list-content-types";
import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";


export const pageProductListProps = () => ({
  previousPage: {
    type: Boolean,
    default: false
  },
  appliedFilters: {
    type: Array,
    default: []
  },
  productsListMode: {
    type: String,
    default: 'Grid'
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  showAboLad: {
    type: Boolean,
    required: false,
    default: false
  },
  showAboLadRenouvellement: {
    type: Boolean,
    required: false,
    default: false
  },
  isPro: {
    type: Boolean,
    required: false,
    default: false
  },
  boiteLiens: {
    type: Array,
    required: false,
    default: () => []
  },
  ...pushProps()
})

export const usePageProductList = (props) => {

  const productsStore = useProductsStore()
  const magasinStore = useMagasinStore()
  const datalayerStore = useDatalayerStore()

  const { getPushData } = usePush(props.pushZones)

  const { trackEvent } = useInteractionDoneTracking();

  const showPlanningClickCollectTraiteur = ref(false)
  const showPlanningClickCollectTraiteurNoel = ref(false)


  const {
    breadcrumbs,
    filters,
    pagination,
    hasPorteurDlc,
    productsList,
    sortCriteria,
    appliedFilters,
    firstPageIndex,
    lastPageIndex,
    produitsDejaAchetes,
    title,
    description,
    contentType,
    filterVisible,
    sections,
    isLoadingInfinite
  } = storeToRefs(productsStore)

  const { hasClickAndCollectTraiteurNoel, hasClickAndCollectTraiteur } = storeToRefs(magasinStore)
  const { isPro } = storeToRefs(useClientStore());
  const { setLocation } = datalayerStore;

  const pagePushZonesGridCodes = pagesNiv3et4Codes.GRID_NIV3;

  const pushPositionsObject = useRuntimeConfig().public.MERCH_DP_POSITIONS;

  const doubleVignetteDPPositions = useRuntimeConfig().public.DOUBLE_VIGNETTE_DP_POSITIONS;

  const isPromo = computed(() => {
    return contentType.value === contentTypes.PROMO;
  });

  const quickFilters = computed(() => {
    if (isPro.value) {
      return filters.value.filter(quickFilter => quickFilter.is_promoted === true)
    }
    return filters.value.filter(quickFilter => quickFilter.is_promoted === true && !quickFilter.is_cora_pro)
  })

  const pushDataExplications = computed(() => {
    return getPushData(pagesNiv3et4Codes.EXPLICATIONS, 1);
  })

  const {
    setShowMoreClicked: showMoreButtonClicked,
    setShowPreviousClicked: showPreviousButtonClicked,
    setScrollMeaId,
    updateFilterVisible
  } = productsStore;

  const updateMeaId = (id) => {
    setScrollMeaId(id);
  }

  const { layout, fetchFiltredProducts, loadNextPage, onProductIntersect } =
    useContainerProductList(
      productsList.value,
      sortCriteria.value,
      appliedFilters.value
    );

  const ourSelection = computed(() => {
    const selectedProducts =
      props.pushZones &&
      props.pushZones.find(
        (e) => e.code === pagesNiv3et4Codes.Niv3_4_PRODUITS
      );
    return selectedProducts ? selectedProducts.products : [];
  })

  const toggleFilter = (value) => {
    updateFilterVisible(value !== undefined ? value : !filterVisible.value);
    if (filterVisible.value) {
      trackEvent({
        actionGA: trackingCodes.ACTIONGA.plusDeFiltres,
        categoryGA: trackingCodes.CATEGORYGA.filter,
      });
    }
  }
  const getOurSelectionPush = (code) => {
    const pushElement =
      props.pushZones && props.pushZones.find(e => e.code === code);
    return pushElement && pushElement.html_content !== "null"
      ? pushElement
      : null;
  }
  const isAbonnementLad = (zoneMerch) => {
    return zoneMerch && zoneMerch.html_content && zoneMerch.html_content.includes("abonnement_lad");
  }
  const isTraiteurDeFete = (zoneMerch) => {
    return zoneMerch && zoneMerch.html_content && zoneMerch.html_content.includes("traiteur_noel");
  }
  const isTraiteurPermanent = (zoneMerch) => {
    return zoneMerch && zoneMerch.html_content && zoneMerch.html_content.includes("traiteur_permanent");
  }
  const showTraiteurDeFete = (zoneMerch) => {
    return isTraiteurDeFete(zoneMerch) && hasClickAndCollectTraiteurNoel.value && !props.isPro
  }
  const showTraiteurPermanent = (zoneMerch) => {
    return isTraiteurPermanent(zoneMerch) && hasClickAndCollectTraiteur.value && !props.isPro
  }
  const changeAppliedFilters = (checked, code, value, libelle, facette, isQuickFilter) => {
    const filters = [{
      checked,
      code,
      value,
      slider: false
    }];
    fetchFiltredProducts({
      filters,
      page: 1
    });
    if (checked && isQuickFilter) {
      trackEvent({
        actionGA: trackingCodes.ACTIONGA.quickFilter,
        categoryGA: trackingCodes.CATEGORYGA.filter,
        labelGA: libelle === '1' ? facette : libelle
      });
    }
  }

  const mounted = () => {
    setLocation("ListingProduit")
  }

  return {
    pagesNiv3et4Codes,
    showPlanningClickCollectTraiteur,
    showPlanningClickCollectTraiteurNoel,
    breadcrumbs,
    filters,
    quickFilters,
    pagination,
    hasPorteurDlc,
    hasClickAndCollectTraiteurNoel,
    hasClickAndCollectTraiteur,
    ourSelection,
    layout,
    pagePushZonesGridCodes,
    firstPageIndex,
    lastPageIndex,
    produitsDejaAchetes,
    isPro,
    pushPositionsObject,
    doubleVignetteDPPositions,
    productsList,
    pagination,
    appliedFilters,
    title,
    description,
    isPromo,
    filterVisible,
    sections,
    isLoadingInfinite,
    pushDataExplications,
    changeAppliedFilters,
    fetchFiltredProducts,
    loadNextPage,
    onProductIntersect,
    showMoreButtonClicked,
    showPreviousButtonClicked,
    updateMeaId,
    toggleFilter,
    getOurSelectionPush,
    isAbonnementLad,
    isTraiteurDeFete,
    isTraiteurPermanent,
    showTraiteurDeFete,
    showTraiteurPermanent,
    getPushData,
    mounted
  }
}